import { InvalidDependencyTypeError } from '../../errors/InvalidDependencyTypeError';
import { DependencyTypes } from '../../enums/DependencyTypes';
export class BaseSeoIndexabilityPolicy {
    dependencies;
    constructor(dependencies) {
        this.dependencies = dependencies;
    }
    async shouldIndex() {
        if (!this.isIndexabilityPolicyDependencies()) {
            throw new InvalidDependencyTypeError();
        }
        return this.isIndexable();
    }
    async generateSitemapUrls() {
        if (!this.isSitemapUrlGeneratorDependencies()) {
            throw new InvalidDependencyTypeError();
        }
        return await this.generateUrls();
    }
    async isIndexable() {
        return await this.checkRulesForSearch(this.dependencies);
    }
    async checkRulesForSearch(dependencies) {
        for (const rule of this.rules) {
            const result = await rule.forSearch(dependencies);
            if (!result) {
                return false;
            }
        }
        return true;
    }
    async checkRulesForSitemap(filterKeyValues) {
        for (const rule of this.rules) {
            const result = await rule.forSitemapGenerator(filterKeyValues);
            if (!result) {
                return false;
            }
        }
        return true;
    }
    isIndexabilityPolicyDependencies() {
        return this.dependencies.dependencyType === DependencyTypes.SEARCH;
    }
    isSitemapUrlGeneratorDependencies() {
        return this.dependencies.dependencyType === DependencyTypes.SITEMAP_GENERATOR;
    }
}
